import util from '@bmp-vue/core/api/util'
import downloadUtil from '../downloadUtil'

const controller = 'Arrc018';
export default Object.assign({}, util.GetCrud(controller, ['getall']), {
    GetAllArquivos: function (dto) {
        return util.Axios.GetAll(controller + "/Arquivo", dto)
    },
    GetAllTentativaEnvio: function (dto) {
        return util.Axios.GetAll(controller + "/Arquivo/" + dto.nomeArquivo + "/Tentativas", null)
    },
    DownloadArrc018BackupFile: function (filename, extensao, date) {
        return downloadUtil.Axios.DownloadXmlFile(
            controller + `/ArquivoArrc018/S3/${filename}/Download`,
            {
                extensao,
                date
            },
            `${filename}${extensao}`
        )
    },
    ReenviarArquivoArrc018Mis: function (dto) {
        return util.Axios.Post(controller + "/ArquivoArrc018/Reenviar", dto);
    },
});  
